/*
 * Shared SEO / structured-data configuration.
 *
 * CommonJS (module.exports) on purpose: this module is consumed both by the
 * React components (via webpack/babel interop) AND by the build-time prerender
 * script scripts/inject-route-meta.js (via require), so the JSON-LD emitted
 * client-side and the JSON-LD baked into the static HTML stay in lockstep.
 *
 * Nothing personal is hardcoded beyond what the brand already publishes:
 * the author name and org name live here as single sources of truth.
 */
const BASE_URL = "https://nigelsnotebook.com";
const SITE_NAME = "Nigel's Notebook";
const AUTHOR = "Chris Ness";
const LOGO_URL = `${BASE_URL}/logo512.png`;
const OG_IMAGE_URL = `${BASE_URL}/images/og.jpg`;
const DEFAULT_DESC =
  "Free horse racing tools — going bias, trainer heatmaps, pace maps, bet calculator and more.";

module.exports = {
  BASE_URL,
  SITE_NAME,
  AUTHOR,
  LOGO_URL,
  OG_IMAGE_URL,
  DEFAULT_DESC,
};
